import { render } from "./Announcement.vue?vue&type=template&id=221dc18d&scoped=true"
import script from "./Announcement.vue?vue&type=script&lang=js"
export * from "./Announcement.vue?vue&type=script&lang=js"

import "./Announcement.vue?vue&type=style&index=0&id=221dc18d&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\digital-gate\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-221dc18d"]])

export default __exports__